const hasText = (v) => Boolean(String(v || "").trim());
const hasRichText = (v) => {
  const stripped = String(v || "")
    .replace(/<[^>]*>/g, "")
    .trim();
  return stripped.length > 0;
};
const hasSelect = (v) => Boolean(v?.value);
const hasArray = (v) => Array.isArray(v) && v.length > 0;

const hasWarrantySelection = (formData) =>
  Array.isArray(formData.warranty) && formData.warranty.length > 0;

const hasInstallationSelection = (formData) =>
  Array.isArray(formData.installation)
    ? formData.installation.length > 0
    : hasText(formData.installation);

const hasStoreButtonSelection = (formData) =>
  Boolean(formData.add_to_cart || formData.buy_now || formData.inquiry);

const hasGstConfigured = (formData) => {
  if (formData.gst_type === "excluded") {
    return hasText(formData.gst_percentage);
  }
  if (formData.gst_type === "included") {
    return false;
  }
  return hasText(formData.gst);
};

const hasSalePrice = (formData) => {
  const price = String(formData.discountPrice ?? "").trim();
  return price !== "" && price !== "0" && price !== "0.00";
};

const countFilled = (checks) => {
  const total = checks.length;
  if (!total) return 0;
  const filled = checks.filter(Boolean).length;
  return Math.round((filled / total) * 100);
};

/** Shared completion checks — only user-provided values, no form defaults. */
const baseChecks = (formData) => [
  hasText(formData.title),
  hasRichText(formData.short_description),
  hasArray(formData.image),
  hasArray(formData.gallery),
  hasSelect(formData.category),
  hasSelect(formData.stock),
  hasSelect(formData.status),
  hasRichText(formData.description),
  hasArray(formData.key_features),
  hasArray(formData.specifications),
  Boolean(formData.brand_name?.value || formData.brand_name),
  hasText(formData.meta_title),
  hasText(formData.meta_description),
  hasArray(formData.meta_keywords),
  hasArray(formData.tags),
  hasArray(formData.faqs),
  hasText(formData.hsn),
  hasWarrantySelection(formData),
  hasArray(formData.categorytype),
  hasText(formData.delivery_days),
];

export function calculateSimpleProductCompletion(formData) {
  return countFilled([
    ...baseChecks(formData),
    hasText(formData.originalPrice),
    hasSalePrice(formData),
    hasGstConfigured(formData),
    hasInstallationSelection(formData),
    hasStoreButtonSelection(formData),
  ]);
}

export function calculateVariableProductCompletion(formData) {
  return countFilled([
    ...baseChecks(formData),
    hasArray(formData.attributes),
    hasArray(formData.variations),
    hasGstConfigured(formData),
    hasInstallationSelection(formData),
    hasStoreButtonSelection(formData),
  ]);
}

export function calculateGroupedProductCompletion(formData) {
  return countFilled([
    ...baseChecks(formData),
    hasArray(formData.grouped_products),
    hasText(formData.originalPrice),
    hasSalePrice(formData),
    hasGstConfigured(formData),
    hasInstallationSelection(formData),
    hasStoreButtonSelection(formData),
  ]);
}
